module.exports = __webpack_public_path__ + "media/country_flags/by-25028692.png";